import React, { useEffect } from 'react';
import { faInfo, faQuestionCircle, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  useExportFileMutation,
  useLazyOfflineUPloadOptionsQuery,

} from '../../../../../features/authentication/assignmentApislice';
import CustomToast from '../../../../../components/Toast';
import { selectCurrentToken } from '../../../../../features/authentication/authSlice';
import { useSelector } from 'react-redux';
import { Button, Form, ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import HesSpinner from '../../../../../components/loadingOverlay/hesSpinner';
import appConfig from '../../../../../app-config';
import { useAssignmentContext } from '../../../context';
import { useParams } from 'react-router';

const selfAssignments = [
  {
    label: 'Format 1',
    value: 0
  },
  {
    label: 'Format 2',
    value: 1
  },
  {
    label: 'Format 3',
    value: 2
  }
];

const UploadOfflineAnswers = () => {
  const accessToken = useSelector(selectCurrentToken);
  const [files, setFiles] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [exportFile] = useExportFileMutation();
  const [format, setFormat] = React.useState(0);
  const baseUrl = appConfig.apiBaseUrl;
  const { assignmentName } = useAssignmentContext();
  const [blankCode, setBlankCode] = React.useState('$');
  const [alertCodes, setAlertCodes] = React.useState('*');
  const [offlineUPloadOptions] = useLazyOfflineUPloadOptionsQuery();
  const { Id } = useParams();

  useEffect(() => {
    fetchingOfflineUploadOptions();
  }, []);
  const fetchingOfflineUploadOptions = async () => {
    try {
      const response = await offlineUPloadOptions().unwrap();
      const { blankCode, alertCode, format } = response;
      setBlankCode(blankCode);
      setAlertCodes(alertCode);
      setFormat(format);
    } catch (err) {
      CustomToast('Something went wrong', 'error');
    }
  };


  let request = (obj) => {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open(obj.method || 'POST', obj.url);
      xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr);
        } else {
          reject(xhr);
        }
      };
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send(obj.body);
    });
  };

  const exportHandler = async () => {
    const options = {
      assignmentId: Id,
      classId: -1
    };
    try {
      await exportFile(options).unwrap();
    } catch (err) {
      if (err.data) {
        const csvData = err.data;
        const fileName = assignmentName + '.csv';
        // Create a Blob object from the CSV data
        const blob = new Blob([csvData], { type: 'text/csv' });
        // Create a URL for the Blob object
        const url = URL.createObjectURL(blob);
        // Create a link element to trigger the download
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        // Append the link to the document body and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up by revoking the URL object
        URL.revokeObjectURL(url);
      } else {
        CustomToast('File export failed', 'error');
      }
    }
  };

  const formatHandler = (e) => {
    setFormat(e.target.value);
  };
  const uploadHandler = async () => {
    // const formData = new FormData();
    // formData.append('file', files);
    setIsLoading(true);
    const options = {
      offlineFormat: format,
      assignmentId: Id,
      blankCode: encodeURIComponent(blankCode ?? ""),
      alertCodes: encodeURIComponent(alertCodes ?? "")
    };

    let formData = new FormData();
    formData.append('file', files);

    request({
      url: `${baseUrl}/Assignment/${options.assignmentId}/UploadOfflineCsv?offlineFormat=${options.offlineFormat}&blankCode=${options.blankCode}&alertCodes=${options.alertCodes}`,
      body: formData
    })
      .then((data) => {
        if (data.status === 200) {
          const message = data.responseText;
          const jsonObject = JSON.parse(message);
          const errorMessage = jsonObject.error;
          const success = jsonObject.ok;
          const successOrError = success ? 'success' : 'error';
          setIsLoading(false);
          if (success) {
            CustomToast('File uploaded successfully', successOrError);
          } else {
            CustomToast(errorMessage, successOrError);
          }
        }
        // do action
      })
      .catch((error) => {
        setIsLoading(false);
        CustomToast(error.response, 'error');
        console.log(error);
      });
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    console.log('File selected:', file);
    setFiles(file);
  };
  return (
    <div className="white-card">
      <div className="d-flex justify-content-between flex-wrap mb-3">
      </div>

      <div className="col-12 info-text d-flex align-items-start mb-4">
        <span className="flex-shrink-0">
          <FontAwesomeIcon icon={faInfo} />
        </span>
        <p>
          If there are students who have been assigned the current assignment in{' '}
          <strong>Offline</strong> mode, you can upload the answers by uploading a CSV
          (comma-separated-value) file that contains the answers. If your students are using scan
          forms or 'clicker' systems to answer the questions, your vendor may be able to provide you
          with software to create the upload files. (<strong>Mac Users</strong>: If the upload of
          your CSV file fails, try renaming the file so the file extension is .TXT instead of .CSV)
        </p>
      </div>

      <div className="row">
        <div className="col-lg-6 upload-offline-left">
          <div className="mb-3 export-template">
            <p>
              Export spreadsheet file for creating your own Offline Upload File{' '}
              <OverlayTrigger
                key="textToSpeech"
                placement="right"
                overlay={
                  <Tooltip className="custom-tooltip">
                    <div id="helpDiv">
                      If you have students who are working on assignments offline but are unable to
                      use scanner sheets, you can input their answers yourself. To do so, use this
                      Export option to download a CSV spreadsheet file where you can type their
                      answers in columns 3-n. Then use the <b>Upload Offline Answers</b> feature,
                      using File Format 2, to upload the answers into the assignment records.
                      <br />
                      <br />
                      Note that the student accounts must include Identification numbers. Contact
                      your Castle Learning administrator if your students do not have Identification
                      numbers in their account record.
                    </div>
                  </Tooltip>
                }>
                <FontAwesomeIcon className="ms-2" icon={faQuestionCircle} />
              </OverlayTrigger>
            </p>
            <button onClick={exportHandler} className="btn btn-castleWhite">
              Export spreadsheet
            </button>
          </div>

          <p>
            Processing will stop when the first error in the file is detected. If an error is found,
            correct the upload file and re-upload it. The file must consist of one row per student,
            with the following columns (note that this feature requires that the student
            identification number was included when the student accounts were created):
          </p>
          <h6>Format 1</h6>
          <ul className="mb-3 p-0">
            <li>
              <strong>Column 1</strong>: The student identification number that is stored in the
              student's account.
            </li>
            <li>
              <strong>Columns 2-n</strong>: The multiple choice answer for each question.
            </li>
          </ul>
          <h6>Format 2</h6>
          <ul className="mb-3 p-0">
            <li>
              <strong>Column 1</strong>: Student name
            </li>
            <li>
              <strong>Columns 2-n</strong>:The student identification number that is stored in the
              student's account.
            </li>
            <li>
              <strong>Columns 2-n</strong>:The multiple choice answer for each question.
            </li>
          </ul>
          <h6>Format 3</h6>
          <ul className="mb-3 p-0">
            <li>
              <strong>Column 1</strong>:Informational headers for the rows (ie. Student
              Identification, Q1-n)
            </li>
            <li>
              <strong>Row 1</strong>: Student identification number that is stored in the student's
              account
            </li>
            <li>
              <strong>Row 2-n</strong>: The multiple choice answer for each question.
            </li>
          </ul>
        </div>

        <div className="col-lg-6">
          <div className="upload-offline-right">
            <h4 className="primary-title ">Upload Offline Answers</h4>
            <p>Options</p>
            <div className="row mb-3">
              <div className="col-lg-4">
                <label className="form-label">
                  File format
                  <OverlayTrigger
                    key="textToSpeech"
                    placement="right"
                    overlay={
                      <Tooltip className="custom-tooltip">
                        <div>
                          Your scanner/clicker export program may offer you some export options.
                          Only the student identification and the answers are used by Castle
                          Learning. Also acceptable is a file with the student names in column 1.
                          <br />
                          <br />
                          <b>Format 1</b>:
                          <br />
                          &nbsp;&nbsp;&nbsp;Column 1: student identification
                          <br />
                          &nbsp;&nbsp;&nbsp;Columns 2-n: answers
                          <br />
                          <b>Format 2</b>:
                          <br />
                          &nbsp;&nbsp;&nbsp;Column 1: student name
                          <br />
                          &nbsp;&nbsp;&nbsp;Column 2: student identification
                          <br />
                          &nbsp;&nbsp;&nbsp;Columns 3-n: answers
                          <br />
                          <b>Format 3</b>:
                          <br />
                          &nbsp;&nbsp;&nbsp;Column 1: headers for the rows
                          <br />
                          &nbsp;&nbsp;&nbsp;Row 1: student identification
                          <br />
                          &nbsp;&nbsp;&nbsp;Row 2-n: answers
                        </div>
                      </Tooltip>
                    }>
                    <FontAwesomeIcon className="ms-2" icon={faQuestionCircle} />
                  </OverlayTrigger>
                </label>
                <select
                  onChange={formatHandler}
                  className="form-select"
                  aria-label="Default select example"
                  value={format}>
                  {selfAssignments.map((item, index) => (
                    <option key={index}  value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <label className="form-label">
                Alert me (and do not process) if any of these characters are stored as answers in
                the file{' '}
                <OverlayTrigger
                  key="textToSpeech"
                  placement="top"
                  overlay={
                    <Tooltip className="custom-tooltip">
                      Your scanner export program may use an asterisk (*) to indicate that the
                      student selected more than one answer. Include the codes you do not want to be
                      automatically marked as incorrect. These will be flagged as 'invalid' and you
                      will need to modify the upload file manually before resubmitting it.
                    </Tooltip>
                  }>
                  <FontAwesomeIcon className="ms-2" icon={faQuestionCircle} />
                </OverlayTrigger>
              </label>
              <div className="col-lg-4">
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setAlertCodes(e.target.value)}
                  value={alertCodes}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="form-label">
                The following character indicates 'no selection'{' '}
                <OverlayTrigger
                  key="textToSpeech"
                  placement="top"
                  overlay={
                    <Tooltip className="custom-tooltip">
                      Your scanner/clicker export program may use a character to indicate that no
                      selection was made by the student. Setting this parameter prevents flagging it
                      as an error in the upload file.
                    </Tooltip>
                  }>
                  <FontAwesomeIcon className="ms-2" icon={faQuestionCircle} />
                </OverlayTrigger>
              </label>
              <div className="col-lg-4">
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setBlankCode(e.target.value)}
                  value={blankCode}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-12">
                <label className="form-label">
                  Select Upload File{' '}
                  <OverlayTrigger
                    key="textToSpeech"
                    placement="top"
                    overlay={
                      <Tooltip className="custom-tooltip">
                        The file must be a CSV file or a text file. If it is a text file, the column
                        data must be separated by commas and the student name, if included, must be
                        surrounded by double quotes.
                      </Tooltip>
                    }>
                    <FontAwesomeIcon className="ms-2" icon={faQuestionCircle} />
                  </OverlayTrigger>
                </label>
                <div
                  className="custom-upload position-relative d-flex flex-column justify-content-center align-items-center p-3 text-center"
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.dataTransfer.dropEffect = 'copy';
                  }}
                  onDragEnter={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const file = e.dataTransfer.files[0];
                    console.log('File dropped:', file);
                    setFiles(file);
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const file = e.dataTransfer.files[0];
                    console.log('File dropped:', file);
                    setFiles(file);
                    // Do something with the file here
                  }}>
                  <input
                    onChange={handleFileUpload}
                    className="form-control position-absolute w-100 h-100 top-0 start-0"
                    type="file"
                  />
                  <span className="d-block mb-2">
                    {' '}
                    <FontAwesomeIcon icon={faDownload} />
                  </span>
                  <p className="mb-0">
                    <strong>Click to upload</strong> or Drag and drop file
                  </p>
                  {files && (
                    <div className="mt-3">
                      <p>{files.name}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end">
              <ListGroup.Item>
                {isLoading && (
                  <div style={{ height: '65%', top: '10px', position: 'absolute', left: '12%' }}>
                    <HesSpinner />
                  </div>
                )}
                <Button
                  disabled={isLoading}
                  onClick={uploadHandler}
                  variant="castleRed"
                  className="submitButton"
                  type="submit">
                  Upload and Process
                </Button>
              </ListGroup.Item>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadOfflineAnswers;
